import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AdminPanel from "./Pages/AdminPanel";
import App from "./Pages/App";
import SuccessPage from "./Pages/SuccessPage";
import PrivacyPolicy from "./Pages/PrivacyPolicy";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        {/* <Route path="/admin" element={<AdminPanel />} /> */}
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/privacy" element={<PrivacyPolicy/>} />
      </Routes>
    </Router>
  </React.StrictMode>
);
